import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Client } from '../client';
import { CompanyService, Organization } from '../services/company/company.service';
import { ErrorReportingService } from '../services/errorReporting/error-reporting.service';
import { ErrorReportFactory } from '../services/errorReporting/errorReport';

@Component({
    templateUrl: './clients.component.html',
    styleUrls: ['./clients.component.css'],
    standalone: false
})
export class ClientsComponent implements OnInit {
  @Input() product: any;
  @Output() notify = new EventEmitter();
  displayedColumns: string[] = ['organizationId', 'name', 'actions'];
  dataSource: Organization[];

  constructor(private organizationService: CompanyService, private errorLogger: ErrorReportingService) { }

  async ngOnInit(): Promise<void> {
    const companyId = 1; // TODO: Use current user's company
    try {
      this.dataSource = await this.organizationService.getOrganizations(companyId);
    } catch (err) {
      this.errorLogger.submitErrorReport(
        ErrorReportFactory.newErrorReport(`Failed to get list of organizations for company ${companyId}`, err));
    }
  }

  onSubmit(newClient: any): void {
    console.warn('Client has been added', newClient);
  }
}
